module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cp_stills_pet_500_pwd_frutas_trop.b96073cb.png";